angular.module('unica_media_moderation.media_controllers', [])

.controller('MediaModerationBasicController',
	function(
		$rootScope, $scope, $stateParams
	) {

	$scope.forms = {};

	$rootScope.mediaData = {
		event_id: $stateParams.event_id,
		files: []
	};

});


